import React from "react";
import { Box, Rating, Typography } from "@mui/material";
import { Styles } from "./styles";
import TrustedImg from "../../../../Assets/images/icons/trusted.svg";
import dayjs from "dayjs";
import Flag from "react-world-flags";

const MainDetails = ({ data }) => {
  const calculateDuration = (date) => {
    if (!date) return "Unknown";

    const now = dayjs();
    const registeredDate = dayjs(date);
    const years = now.diff(registeredDate, "year");
    const months = now.diff(registeredDate.add(years, "year"), "month");

    // Build the duration string
    const yearText = years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "";
    const monthText =
      months > 0 ? `${months} month${months > 1 ? "s" : ""}` : "";

    return [yearText, monthText].filter(Boolean).join(" ");
  };
  return (
    <Styles>
      <Box className="main-details-container">
        <Box className="header-data">
          <Box className="panel-info">
            {(data?.logo || data?.customLogo) && (
              <div className="logo-container">
                {data?.logo ? (
                  <img
                    src={data?.logo || data?.customLogo}
                    alt="panel_logo"
                    className="panel-logo"
                  />
                ) : (
                  <div className="final-logo-container">
                    <Typography
                      sx={{
                        fontSize: `${data?.customLogo?.fontSize}`,
                        color: data?.customLogo?.color,
                        fontFamily: data?.customLogo?.fontFamily,
                      }}
                      className="final-logo"
                    >
                      {data?.customLogo?.logoName || "LOREM"}
                    </Typography>
                  </div>
                )}
              </div>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "calc(100% - 140px)",
              }}
            >
              <div className="title-container">
                <Typography className="title">{data?.smmpanel_name}</Typography>
                {data?.trust === 1 && <img src={TrustedImg} alt="trusted" />}
              </div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Typography
                  sx={{
                    lineHeight: "20px",
                    fontSize: { xs: "14px", sm: "18px" },
                    fontWeight: "400",
                  }}
                  className="offer-details-fonts"
                >
                  {" "}
                  {data?.rate?.avg}{" "}
                </Typography>
                <Rating
                  value={data?.rate?.avg}
                  readOnly
                  sx={{ fontSize: { xs: "1.2rem", sm: "1.7rem" } }}
                  className="offer-details-fonts"
                />
                <Typography
                  sx={{
                    lineHeight: "20px",
                    whiteSpace: "nowrap",
                    fontSize: { xs: "12px", sm: "18px" },
                    fontWeight: "400",
                  }}
                  className="offer-details-fonts"
                >
                  {" "}
                  {data?.count_review} Reviews{" "}
                </Typography>
              </Box>
              <a
                href={data?.smmpanel_url}
                target="_blank"
                className="panel-url"
              >
                {data?.smmpanel_url}
              </a>
            </Box>
          </Box>
          {(data?.country_code || data?.country_name) && (
            <Typography className="panel-description">
              <span>
                Nationality:
                <span
                  className={`${
                    data?.reading_status === "not_read"
                      ? "text-[#f7cb73]"
                      : data?.reading_status === "success"
                      ? "text-[#28a745]"
                      : "text-[#ff6877]"
                  }`}
                >
                  {" "}
                </span>
              </span>
              {data?.country_code && (
                <Flag
                  code={data?.country_code}
                  style={{ width: "20px", height: "15px" }}
                />
              )}
              {data?.country_name && <span>{data?.country_name}</span>}
            </Typography>
          )}
          {(data?.reading_status || data?.reading_type) && (
            <Typography className="panel-description">
              {data?.reading_status && (
                <span>
                  Reading status:
                  <span
                    className={`${
                      data?.reading_status === "not_read"
                        ? "text-[#f7cb73]"
                        : data?.reading_status === "success"
                        ? "text-[#28a745]"
                        : "text-[#ff6877]"
                    }`}
                  >
                    {" "}
                    {data?.reading_status === "not_read"
                      ? "Not read"
                      : data?.reading_status === "success"
                      ? "Success"
                      : "Failed"}
                  </span>
                </span>
              )}
              {data?.reading_status && data?.reading_type && " / "}
              {data?.reading_type && (
                <span>Reading Type: {data?.reading_type}</span>
              )}
            </Typography>
          )}
          {data?.description && (
            <Typography className="panel-description">
              description: {data?.description}
            </Typography>
          )}
          {data?.smmpanel_notice && (
            <Typography className="panel-description">
              smmpanel notice: {data?.smmpanel_notice}
            </Typography>
          )}
        </Box>
        <Box className="panel-another-data">
          <Typography className="panel-description">
            Expired status:{" "}
            <span
              className={`${
                data?.expired ? "text-[#ff6877]" : "text-[#28a745]"
              }`}
            >
              {data?.expired ? "Expired" : "Valid"}
            </span>
          </Typography>
          {data?.smmpanel_domain_registered !== "0000-00-00" && (
            <Typography className="panel-description">
              Domain Creating Date : {data?.smmpanel_domain_registered} (
              {calculateDuration(data?.smmpanel_domain_registered) ||
                "Unknown duration"}
              )
            </Typography>
          )}
          {data?.smmpanel_domain_expires !== "0000-00-00" && (
            <Typography className="panel-description">
              Domain Expired date : {data?.smmpanel_domain_expires}
            </Typography>
          )}
          {data?.payment_method?.length > 0 && (
            <Box className="payment-methods">
              <Typography className="title">Panel Payment Methods</Typography>
              <Typography className="data">
                {data?.payment_method?.map((item, idx) => {
                  return (
                    <span key={idx}>
                      {item} {idx !== data?.payment_method?.length - 1 && "|"}
                    </span>
                  );
                })}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Styles>
  );
};

export default MainDetails;
